import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Projects from "./pages/ProjectsPage";
import Resume from "./pages/Resume";
import ContactPage from "./pages/ContactPage";
import Blog from "./pages/Blog";
import Experience from "./pages/Experience";
import ProjectDetailRouter from "./pages/ProjectDetailRouter";
import ResumeRedirect from "./pages/ResumeRedirect";
import LinkedInRedirect from "./pages/LinkedInRedirect";
import SWERedirect from "./pages/SWERedirect";
import ResumePageRedirect from "./pages/ResumePageRedirect";
import { Analytics } from "@vercel/analytics/react";
import { PDFAuthProvider } from "./contexts/PDFAuthContext";
import { UserPreferenceProvider } from "./contexts/UserPreferenceContext";

const App = () => {
  return (
    <PDFAuthProvider>
      <UserPreferenceProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/me" element={<ResumeRedirect />} />
              <Route path="/linkedin" element={<LinkedInRedirect />} />
              <Route path="/swe" element={<SWERedirect />} />
              <Route path="/r" element={<ResumePageRedirect />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/projects/:id" element={<ProjectDetailRouter />} />
            </Routes>
            <Analytics />
          </Layout>
        </Router>
      </UserPreferenceProvider>
    </PDFAuthProvider>
  );
};

export default App;
